export default __webpack_public_path__ + "static/media/navIcon.c94960a5.svg";